import React from 'react';

import { useTheme } from 'styled-components';

import Chip from 'components/Chip/Chip';

import { AcknowledgementRequestStatus } from 'utils/api/modules/entities/entities.types';

interface RequestStatusChipProps {
  status: AcknowledgementRequestStatus;
}

const RequestStatusChip: React.FunctionComponent<RequestStatusChipProps> = ({ status }) => {
  const theme = useTheme();

  const config = ((): { label: string; background: string; foreground: string } => {
    switch (status) {
      case AcknowledgementRequestStatus.Active:
        return {
          label: 'Active',
          background: theme.tint.primary.medium,
          foreground: theme.palette.text.primary,
        };
      case AcknowledgementRequestStatus.Completed:
        return {
          label: 'Completed',
          background: theme.tint.success.medium,
          foreground: theme.palette.success.dark,
        };
      case AcknowledgementRequestStatus.Cancelled:
      default:
        return {
          label: 'Cancelled',
          background: theme.palette.grey[200],
          foreground: theme.palette.text.secondary,
        };
    }
  })();

  return (
    <Chip size="small" label={config.label} colors={{ background: config.background, foreground: config.foreground }} />
  );
};

export default RequestStatusChip;
